import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Login from './login/Login'
import ForgotPassword from './forgotPassword/ForgotPassword'
import Signup from './signup/Signup'

export default class AuthWidget extends Component {

  static propTypes = {
    onClickSignup: PropTypes.func,
    onClickForgotPassword: PropTypes.func,
    defaultMode: PropTypes.oneOf([ 'login', 'signup', 'forgotPassword' ]),
  }

  static defaultProps = {
    defaultMode: 'login',
  }

  state = {
    mode: null,
  }

  componentWillMount () {
    const { defaultMode } = this.props
    if (defaultMode) {
      this.setState({ mode: defaultMode })
    }
  }

  handleClickSignup = () => {
    this.setState({ mode: 'signup' })
  }

  handleClickForgotPassword = () => {
    this.setState({ mode: 'forgotPassword' })
  }

  handleClickLogin = () => {
    this.setState({ mode: 'login' })
  }

  render () {
    const { mode } = this.state

    return (
      <div>
        {mode === 'login' ?
          <div key='0'>
            <Login
              {...this.props}
              reload={true}
              leftAlign={true}
              onClickSignup={this.handleClickSignup}
              onClickForgotPassword={this.handleClickForgotPassword}
            />
          </div>
        : null}

        {mode === 'signup' ?
          <div key='1'>
            <Signup
              {...this.props}
              reload={true}
              leftAlign={true}
              onClickLogin={this.handleClickLogin}
            />
          </div>
        : null}

        {mode === 'forgotPassword' ?
          <div key='0'>
            <ForgotPassword
              {...this.props}
              leftAlign={true}
              onClickLogin={this.handleClickLogin}
            />
          </div>
        : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/AuthWidget.jsx